import { WaitListItemSatus } from 'src/app/core/enums';
import moment from 'moment';
import { TreatmentEntity } from '../interfaces/treatment-entity';
import { TranslateService } from '@ngx-translate/core';
import { Utils } from '../utils';
import { CustomerDetails } from './customer-details';

export class WaitlistModel {
    public SchedulerWaitListID: number;
    public Customer: CustomerDetails;
    public CustomerID: number;
    public CustomerName: string;
    public MobilePhone?: any;
    public BranchName: string;
    public SchedulerName: string;
    public BranchID: number;
    public BusinessID?: number;
    public PriceListRefID?: any;
    public SchedulerID: number;
    public SchedulerResourceID: number;
    public FromDate: string;
    public ToDate: string;
    public FromTime: string;
    public ToTime: string;
    public Duration: number;
    public Priority: number;
    public Order: number;
    public Note: string;
    public HasNote: boolean;
    public HasRoom: boolean;
    public Active: boolean;
    public Color: string;
    public Status: WaitListItemSatus;
    public WeekDays: string;
    public WeekDaysAvailability: boolean[];
    public SchedulerTempWaitListID: number;
    public EventID: number;
    public AppointmentReasonInActivityScope: boolean;

    // commented, will delete once im sure i wont need these
    public TimeRange?: any;
    public UserPractiseID: number;
    public Guid?: any;
    public  FirstDayOfWeek: number;
    public  Min: string;
    public  Max: string;
    public ShowMessageNoDepartmentAutorization: boolean;
    public EntityData?: any;
    public TreatmentsFromPriceList?: any;
    public TreatmentType: number;
    public SelectedTreatmentContainer?: any;
    public TreatmentsFromCard?: any;
    public DoesCustomerHaveToDoTreatments: boolean;
    public Treatments?: any;

    // public Treatments?: TreatmentEntity[];

    constructor(obj?:any, translate?: TranslateService){
        this.SchedulerWaitListID = obj && obj.SchedulerWaitListID || 0;
        this.CustomerID = obj && obj.CustomerID || 0;
        this.Customer = obj && obj.Customer || null;
        this.CustomerName = obj && obj.CustomerName || null;
        this.MobilePhone = obj && obj.MobilePhone || null;
        this.BranchName = obj && obj.BranchName || null;
        this.SchedulerName = obj && obj.SchedulerName || null;
        this.BranchID = obj && obj.BranchID || 0;
        this.BusinessID = obj && obj.BusinessID || 0;
        this.PriceListRefID = obj && obj.PriceListRefID || 0;
        this.SchedulerID = obj && obj.SchedulerID || 0;
        this.SchedulerResourceID = obj && obj.SchedulerResourceID || 0;
        this.FromDate = obj && moment(obj.FromDate).format('DD/MM/YYYY') || moment(null).format('DD/MM/YYYY');
        this.ToDate = obj && moment(obj.ToDate).format('DD/MM/YYYY') || moment(null).format('DD/MM/YYYY');
        this.FromTime = obj && obj.FromTime || null;
        this.ToTime = obj && obj.ToTime || null;
        this.Duration = obj && obj.Duration || 30;
        this.Priority = obj && obj.Priority || null;
        this.Order = obj && obj.Order || null;
        this.Note = obj && obj.Note || null;
        this.HasNote = obj && obj.HasNote || false;
        this.HasRoom = obj && obj.HasRoom || false;
        this.Active = obj && obj.Active || false;
        this.Color = obj && obj.Color || null;
        this.Status = obj && obj.Status || WaitListItemSatus.Pending;
        this.WeekDays = obj && this.buildWeekDayStr(obj.WeekDays,translate) || null;
        this.WeekDaysAvailability = obj && obj.WeekDaysAvailability || null;
        this.SchedulerTempWaitListID = obj && obj.SchedulerTempWaitListID || null;
        this.EventID = obj && obj.EventID || 0;
        this.AppointmentReasonInActivityScope = obj && obj.AppointmentReasonInActivityScope || false;
        
        // commented, will delete once im sure i wont need these
        this.TimeRange = obj && obj.TimeRange || null;
        this.UserPractiseID = obj && obj.UserPractiseID || null;
        this.Guid = obj && obj.Guid || null;
        this.FirstDayOfWeek = obj && obj.FirstDayOfWeek || null;
        this.Min = obj && obj.Min || null;
        this.Max = obj && obj.Max || null;
        this.ShowMessageNoDepartmentAutorization = obj && obj.ShowMessageNoDepartmentAutorization || null;
        this.EntityData = obj && obj.EntityData || null;
        this.TreatmentsFromPriceList = obj && obj.TreatmentsFromPriceList || null;
        this.TreatmentType = obj && obj.TreatmentType || null;
        this.SelectedTreatmentContainer = obj && obj.SelectedTreatmentContainer || null;
        this.TreatmentsFromCard = obj && obj.TreatmentsFromCard || null;
        this.DoesCustomerHaveToDoTreatments = obj && obj.DoesCustomerHaveToDoTreatments || null;
        this.Treatments = obj && obj.Treatments || null;
    }

    // build string for desired weekdays
    buildWeekDayStr(daysArr: boolean[], translate: TranslateService) : string{
        var str = '';
        daysArr.forEach(function(dayActive, i){
            if(dayActive)
                str += translate.instant(`DAYSOFWEEK.${i}`)+', ';
        });
        return str.substring(0, str.length - 2);
    }
}
